import {
  SalaryCardActions,
  SalaryCardActionTypes,
  SalaryCardState,
} from 'store/types/salaryCard'

const initialState: SalaryCardState = {
  orderNoInfo: {
    branchNo: null,
    courier: true,
    urgent: true,
  },
  orderNoInfoError: null,
  orderNoInfoStatus: 'idle',
}

export const orderNumberReducers = (
  state = initialState,
  action: SalaryCardActions
): SalaryCardState => {
  switch (action.type) {
    case SalaryCardActionTypes.FETCH_ORDER_NO_INFO_REQUEST:
      return {
        ...state,
        orderNoInfoStatus: 'loading',
      }
    case SalaryCardActionTypes.FETCH_ORDER_NO_INFO_SUCCESS:
      return {
        ...state,
        orderNoInfoStatus: 'success',
        orderNoInfo: action.payload,
      }
    case SalaryCardActionTypes.FETCH_ORDER_NO_INFO_RESET:
      return {
        ...state,
        ...initialState
      }
    case SalaryCardActionTypes.FETCH_ORDER_NO_INFO_FAILURE:
      return {
        ...state,
        orderNoInfoStatus: 'failed',
        orderNoInfoError: action.payload,
      }
    default:
      return state
  }
}
